import { socialLinks } from '../constants/socialLinks';

export const contact = {
  '@context': 'https://schema.org',
  '@type': 'ContactPage',
  mainEntity: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com/contact/',
    description:
      'Boldare - Digital product creators & consultants with offices in Poland.',
    email: 'hello@boldare.com',
    address: [
      {
        '@type': 'PostalAddress',
        streetAddress: 'Zwycięstwa 52',
        postalCode: '44-100',
        addressLocality: 'Gliwice',
        addressCountry: 'PL',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Wyspa Słodowa 7',
        postalCode: '50-266',
        addressLocality: 'Wrocław',
        addressCountry: 'PL',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Krucza 5',
        postalCode: '00-025',
        addressLocality: 'Warszawa',
        addressCountry: 'PL',
      },
      {
        '@type': 'PostalAddress',
        streetAddress: 'Kurniki 9',
        postalCode: '31-156',
        addressLocality: 'Kraków',
        addressCountry: 'PL',
      },
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'Business',
        email: 'business@boldare.com',
        name: 'Olena Brenych',
        availableLanguage: ['English', 'Polish'],
      },
      {
        '@type': 'ContactPoint',
        contactType: 'General',
        email: 'hello@boldare.com',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Careers',
        email: 'career@boldare.com',
      },
      {
        '@type': 'ContactPoint',
        contactType: 'Public Relations',
        email: 'media@boldare.com',
      },
    ],
    sameAs: Object.values(socialLinks),
  },
};
